import { render, staticRenderFns } from "./ModuleBackground.vue?vue&type=template&id=1156521c&"
import script from "./ModuleBackground.vue?vue&type=script&lang=js&"
export * from "./ModuleBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports